import React from 'react';
import appUserRoutes from "../../../appUserRoutes";
import Modules from "../../../components/TecRmi/Modules";
import Components from "../../../components/TecRmi/Components";
import ServiceProposalTab from "../../../components/TecRmi/ServiceProposalTab";
import TyresTab from "../../../components/TecRmi/TyresTab";
import {TAB_COMPONENTS, TAB_MODULES, TAB_PRIMARY, TAB_SERVICE_PROPOSAL, TAB_TIPS, TAB_TYRES} from "./MainView";
import {Nav, NavItem, TabContent, TabPane} from "reactstrap";
import {NavLink, Redirect, Route, Switch} from "react-router-dom";
import classnames from "classnames";
import PrimaryTab from "./tabs/PrimaryTab";
import ParamsWrapper from "../../../components/TecRmi/ParamsWrapper";
import TipsTab from "../../../components/TecRmi/TipsTab";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import {useTranslation} from "react-i18next";
import TecRmiVehicleTypeSuppliers, {TCD_VEHICLE_TYPE_CAR} from "../../../components/TecRmi/TecRmiVehicleTypeSuppliers";

const TypeIdView = props => {
  const { t } = useTranslation('type_id_view');
  const { ident, showType } = useTecRmi()

  const navItems = [
    {
      key: TAB_PRIMARY,
      label: t('tabs.primary'),
      icon: <i className="fas fa-car" />,
      path: appUserRoutes.tecRmi.tab(ident, TAB_PRIMARY),
      component: PrimaryTab,
    },
    {
      key: TAB_MODULES,
      label: t('tabs.modules'),
      icon: <i className="fas fa-th-large" />,
      path: appUserRoutes.tecRmi.tab(ident, TAB_MODULES),
      component: Modules,
    },
    {
      key: TAB_COMPONENTS,
      label: t('tabs.components'),
      icon: <i className="fas fa-tools" />,
      path: appUserRoutes.tecRmi.tab(ident, TAB_COMPONENTS),
      component: Components,
    },
    {
      key: TAB_SERVICE_PROPOSAL,
      hidden: showType !== TCD_VEHICLE_TYPE_CAR,
      label: t('tabs.service_proposal'),
      icon: <i className="fas fa-cogs" />,
      path: appUserRoutes.tecRmi.tab(ident, TAB_SERVICE_PROPOSAL),
      component: ServiceProposalTab,
    },
    {
      key: TAB_TYRES,
      hidden: showType !== TCD_VEHICLE_TYPE_CAR,
      label: t('tabs.tyres'),
      icon: <i className="fas fa-circle" />,
      path: appUserRoutes.tecRmi.tab(ident, TAB_TYRES),
      component: TyresTab,
    },
    {
      key: TAB_TIPS,
      label: t('tabs.tips'),
      icon: <i className="fas fa-car-crash" />,
      path: appUserRoutes.tecRmi.tab(ident, TAB_TIPS),
      component: TipsTab,
    },
  ]


  return <React.Fragment>
    <Nav tabs style={{zIndex: 3}}>
      {navItems.map(navItem => {
        if(navItem.hidden){
          return null
        }

        const isActive = window.location.pathname.indexOf(navItem.path) >= 0

        return <NavItem key={navItem.key}>
          <NavLink
            className="nav-link"
            to={navItem.path}
          >
            {navItem.icon}
            <span className={classnames({
              'ml-2 d-none d-md-inline': true,
              'd-inline': isActive,
            })}>{navItem.label}</span>
          </NavLink>
        </NavItem>
      })}

      <li className="d-flex ml-auto mr-2 align-items-center">
        <TecRmiVehicleTypeSuppliers />
      </li>
    </Nav>
    <TabContent>
      <TabPane className="w-100">
        <Switch>
          {navItems.map(navItem => <Route
            key={navItem.key}
            history={props.history}
            path={`${navItem.path}*`}
            name={navItem.label}
            render={_p => <ParamsWrapper {..._p} component={navItem.component} />}
          />)}

          <Redirect from={appUserRoutes.tecRmi.main} to={navItems[1].path} />
        </Switch>
      </TabPane>
    </TabContent>
  </React.Fragment>;
};

TypeIdView.propTypes = {

};

export default TypeIdView;